import {
  LIST_VEHICLES,
  LIST_VEHICLES_SUCCESS,
  LIST_VEHICLES_FAILURE,
  CREATE_VEHICLE,
  CREATE_VEHICLE_SUCCESS,
  CREATE_VEHICLE_FAILURE,
  DELETE_VEHICLE,
  DELETE_VEHICLE_SUCCESS,
  DELETE_VEHICLE_FAILURE,
  UPDATE_VEHICLE,
  UPDATE_VEHICLE_SUCCESS,
  UPDATE_VEHICLE_FAILURE,
  GET_VEHICLE_DETAILS,
  GET_VEHICLE_DETAILS_SUCCESS,
  GET_VEHICLE_DETAILS_FAILURE,
  VEHICLE_STATUS_LIST,
  VEHICLE_STATUS_LIST_SUCCESS,
  VEHICLE_STATUS_LIST_FAILURE,
  VEHICLE_TYPE_LIST,
  VEHICLE_TYPE_LIST_SUCCESS,
  VEHICLE_TYPE_LIST_FAILURE,
  VEHICLE_STATUS_CREATE,
  VEHICLE_STATUS_CREATE_SUCCESS,
  VEHICLE_STATUS_CREATE_FAILURE,
  VEHICLE_TYPE_CREATE,
  VEHICLE_TYPE_CREATE_SUCCESS,
  VEHICLE_TYPE_CREATE_FAILURE,
  VEHICLE_STATUS_UPDATE,
  VEHICLE_STATUS_UPDATE_SUCCESS,
  VEHICLE_STATUS_UPDATE_FAILURE,
  VEHICLE_TYPE_UPDATE,
  VEHICLE_TYPE_UPDATE_SUCCESS,
  VEHICLE_TYPE_UPDATE_FAILURE,
  VEHICLE_STATUS_DELETE,
  VEHICLE_STATUS_DELETE_SUCCESS,
  VEHICLE_STATUS_DELETE_FAILURE,
  VEHICLE_TYPE_DELETE,
  VEHICLE_TYPE_DELETE_SUCCESS,
  VEHICLE_TYPE_DELETE_FAILURE,
  VEHICLE_STATUS_DETAILS,
  VEHICLE_STATUS_DETAILS_SUCCESS,
  VEHICLE_STATUS_DETAILS_FAILURE,
  VEHICLE_RECENT_ACTIVITY_LIST,
  VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS,
  VEHICLE_RECENT_ACTIVITY_LIST_FAILURE,
  VEHICLE_SEARCH,
  VEHICLE_SEARCH_SUCCESS,
  VEHICLE_SEARCH_FAILURE,
} from "./actionType";

const initialValue = {
  vehicleList: [],
  vehicleListLoading: false,
  vehicleListError: null,

  vehicleDetails: [],
  vehicleDetailsLoading: false,
  vehicleDetailsError: null,

  vehicleCreate: [],
  vehicleCreateLoading: false,
  vehicleCreateError: null,

  vehicleUpdate: [],
  vehicleUpdateLoading: false,
  vehicleUpdateError: null,

  vehicleDelete: [],
  vehicleDeleteLoading: false,
  vehicleDeleteError: null,

  vehicleStatusList: [],
  vehicleStatusListLoading: false,
  vehicleStatusListError: null,

  vehicleTypeList: [],
  vehicleTypeListLoading: false,
  vehicleTypeListError: null,

  vehicleStatusCreate: [],
  vehicleStatusCreateLoading: false,
  vehicleStatusCreateError: null,

  vehicleTypeCreate: [],
  vehicleTypeCreateLoading: false,
  vehicleTypeCreateError: null,

  vehicleStatusUpdate: [],
  vehicleStatusUpdateLoading: false,
  vehicleStatusUpdateError: null,

  vehicleTypeUpdate: [],
  vehicleTypeUpdateLoading: false,
  vehicleTypeUpdateError: null,

  vehicleStatusDelete: [],
  vehicleStatusDeleteLoading: false,
  vehicleStatusDeleteError: null,

  vehicleTypeDelete: [],
  vehicleTypeDeleteLoading: false,
  vehicleTypeDeleteError: null,

  vehicleStatusDetails: [],
  vehicleStatusDetailsLoading: false,
  vehicleStatusDetailsError: null,

  vehicleRecentActivityList: [],
  vehicleRecentActivityListLoading: false,
  vehicleRecentActivityListError: null,

  vehicleSearch: [],
  vehicleSearchLoading: false,
  vehicleSearchError: null,
};

const Vehicle = (state = initialValue, action) => {
  switch (action.type) {
    case LIST_VEHICLES:
      return {
        ...state,
        vehicleListLoading: true,
        vehicleListError: null,
      };
    case LIST_VEHICLES_SUCCESS:
      return {
        ...state,
        vehicleList: action.payload,
        vehicleListLoading: false,
        vehicleListError: null,
      };
    case LIST_VEHICLES_FAILURE:
      return {
        ...state,
        vehicleList: [],
        vehicleListLoading: false,
        vehicleListError: action.payload,
      };
    case CREATE_VEHICLE:
      return {
        ...state,
        vehicleCreateLoading: true,
        vehicleCreateError: null,
      };
    case CREATE_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicleCreate: action.payload,
        vehicleCreateLoading: false,
        vehicleCreateError: null,
      };
    case CREATE_VEHICLE_FAILURE:
      return {
        ...state,
        vehicleCreate: [],
        vehicleCreateLoading: false,
        vehicleCreateError: action.payload,
      };
    case DELETE_VEHICLE:
      return {
        ...state,
        vehicleDeleteLoading: true,
        vehicleDeleteError: null,
      };
    case DELETE_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicleDelete: action.payload,
        vehicleDeleteLoading: false,
        vehicleDeleteError: null,
      };
    case DELETE_VEHICLE_FAILURE:
      return {
        ...state,
        vehicleDelete: [],
        vehicleDeleteLoading: false,
        vehicleDeleteError: action.payload,
      };
    case UPDATE_VEHICLE:
      return {
        ...state,
        vehicleUpdateLoading: true,
        vehicleUpdateError: null,
      };
    case UPDATE_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicleUpdate: action.payload,
        vehicleUpdateLoading: false,
        vehicleUpdateError: null,
      };
    case UPDATE_VEHICLE_FAILURE:
      return {
        ...state,
        vehicleUpdate: [],
        vehicleUpdateLoading: false,
        vehicleUpdateError: action.payload,
      };
    case GET_VEHICLE_DETAILS:
      return {
        ...state,
        vehicleDetailsLoading: true,
        vehicleDetailsError: null,
      };
    case GET_VEHICLE_DETAILS_SUCCESS:
      return {
        ...state,
        vehicleDetails: action.payload,
        vehicleDetailsLoading: false,
        vehicleDetailsError: null,
      };
    case GET_VEHICLE_DETAILS_FAILURE:
      return {
        ...state,
        vehicleDetails: [],
        vehicleDetailsLoading: false,
        vehicleDetailsError: action.payload,
      };
    case VEHICLE_STATUS_LIST:
      return {
        ...state,
        vehicleStatusListLoading: true,
        vehicleStatusListError: null,
      };
    case VEHICLE_STATUS_LIST_SUCCESS:
      return {
        ...state,
        vehicleStatusList: action.payload,
        vehicleStatusListLoading: false,
        vehicleStatusListError: null,
      };
    case VEHICLE_STATUS_LIST_FAILURE:
      return {
        ...state,
        vehicleStatusList: [],
        vehicleStatusListLoading: false,
        vehicleStatusListError: action.payload,
      };
    case VEHICLE_TYPE_LIST:
      return {
        ...state,
        vehicleTypeListLoading: true,
        vehicleTypeListError: null,
      };
    case VEHICLE_TYPE_LIST_SUCCESS:
      return {
        ...state,
        vehicleTypeList: action.payload,
        vehicleTypeListLoading: false,
        vehicleTypeListError: null,
      };
    case VEHICLE_TYPE_LIST_FAILURE:
      return {
        ...state,
        vehicleTypeList: [],
        vehicleTypeListLoading: false,
        vehicleTypeListError: action.payload,
      };
    case VEHICLE_STATUS_CREATE:
      return {
        ...state,
        vehicleStatusCreateLoading: true,
        vehicleStatusCreateError: null,
      };
    case VEHICLE_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        vehicleStatusCreate: action.payload,
        vehicleStatusCreateLoading: false,
        vehicleStatusCreateError: null,
      };
    case VEHICLE_STATUS_CREATE_FAILURE:
      return {
        ...state,
        vehicleStatusCreate: [],
        vehicleStatusCreateLoading: false,
        vehicleStatusCreateError: action.payload,
      };
    case VEHICLE_TYPE_CREATE:
      return {
        ...state,
        vehicleTypeCreateLoading: true,
        vehicleTypeCreateError: null,
      };
    case VEHICLE_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        vehicleTypeCreate: action.payload,
        vehicleTypeCreateLoading: false,
        vehicleTypeCreateError: null,
      };
    case VEHICLE_TYPE_CREATE_FAILURE:
      return {
        ...state,
        vehicleTypeCreate: [],
        vehicleTypeCreateLoading: false,
        vehicleTypeCreateError: action.payload,
      };
    case VEHICLE_STATUS_UPDATE:
      return {
        ...state,
        vehicleStatusUpdateLoading: true,
        vehicleStatusUpdateError: null,
      };
    case VEHICLE_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        vehicleStatusUpdate: action.payload,
        vehicleStatusUpdateLoading: false,
        vehicleStatusUpdateError: null,
      };
    case VEHICLE_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        vehicleStatusUpdate: [],
        vehicleStatusUpdateLoading: false,
        vehicleStatusUpdateError: action.payload,
      };
    case VEHICLE_TYPE_UPDATE:
      return {
        ...state,
        vehicleTypeUpdateLoading: true,
        vehicleTypeUpdateError: null,
      };
    case VEHICLE_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        vehicleTypeUpdate: action.payload,
        vehicleTypeUpdateLoading: false,
        vehicleTypeUpdateError: null,
      };
    case VEHICLE_TYPE_UPDATE_FAILURE:
      return {
        ...state,
        vehicleTypeUpdate: [],
        vehicleTypeUpdateLoading: false,
        vehicleTypeUpdateError: action.payload,
      };
    case VEHICLE_STATUS_DELETE:
      return {
        ...state,
        vehicleStatusDeleteLoading: true,
        vehicleStatusDeleteError: null,
      };
    case VEHICLE_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        vehicleStatusDelete: action.payload,
        vehicleStatusDeleteLoading: false,
        vehicleStatusDeleteError: null,
      };
    case VEHICLE_STATUS_DELETE_FAILURE:
      return {
        ...state,
        vehicleStatusDelete: [],
        vehicleStatusDeleteLoading: false,
        vehicleStatusDeleteError: action.payload,
      };
    case VEHICLE_TYPE_DELETE:
      return {
        ...state,
        vehicleTypeDeleteLoading: true,
        vehicleTypeDeleteError: null,
      };
    case VEHICLE_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        vehicleTypeDelete: action.payload,
        vehicleTypeDeleteLoading: false,
        vehicleTypeDeleteError: null,
      };
    case VEHICLE_TYPE_DELETE_FAILURE:
      return {
        ...state,
        vehicleTypeDelete: [],
        vehicleTypeDeleteLoading: false,
        vehicleTypeDeleteError: action.payload,
      };
    case VEHICLE_STATUS_DETAILS:
      return {
        ...state,
        vehicleStatusDetailsLoading: true,
        vehicleStatusDetailsError: null,
      };
    case VEHICLE_STATUS_DETAILS_SUCCESS:
      return {
        ...state,
        vehicleStatusDetails: action.payload,
        vehicleStatusDetailsLoading: false,
        vehicleStatusDetailsError: null,
      };
    case VEHICLE_STATUS_DETAILS_FAILURE:
      return {
        ...state,
        vehicleStatusDetails: [],
        vehicleStatusDetailsLoading: false,
        vehicleStatusDetailsError: action.payload,
      };
    case VEHICLE_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        vehicleRecentActivityListLoading: true,
        vehicleRecentActivityListError: null,
      };
    case VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        vehicleRecentActivityList: action.payload,
        vehicleRecentActivityListLoading: false,
        vehicleRecentActivityListError: null,
      };
    case VEHICLE_RECENT_ACTIVITY_LIST_FAILURE:
      return {
        ...state,
        vehicleRecentActivityList: [],
        vehicleRecentActivityListLoading: false,
        vehicleRecentActivityListError: action.payload,
      };
    case VEHICLE_SEARCH:
      return {
        ...state,
        vehicleSearchLoading: true,
        vehicleSearchError: null,
      };
    case VEHICLE_SEARCH_SUCCESS:
      return {
        ...state,
        vehicleSearch: action.payload,
        vehicleSearchLoading: false,
        vehicleSearchError: null,
      };
    case VEHICLE_SEARCH_FAILURE:
      return {
        ...state,
        vehicleSearch: [],
        vehicleSearchLoading: false,
        vehicleSearchError: action.payload,
      };

    default:
      return state;
  }
};

export default Vehicle;
